"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MONAD_TESTNET = exports.BASE_TESTNET = exports.BASE_MAINNET = exports.AVALANCHE_TESTNET = exports.AVALANCHE_MAINNET = exports.OP_TESTNET = exports.OP_MAINNET = exports.MANTLE_TESTNET = exports.MANTLE_MAINNET = exports.OKC_TESTNET = exports.OKC_MAINNET = exports.POLYGON_TESTNET = exports.POLYGON_MAINNET = exports.ARBITRUM_TESTNET = exports.ARBITRUM_MAINNET = exports.ETH_TESTNET = exports.ETH_MAINNET = exports.BSC_TESTNET = exports.BSC_MAINNET = exports.CARBON_EVM_MAINNET = exports.CARBON_EVM_TESTNET = exports.CARBON_EVM_DEVNET = exports.CARBON_EVM_LOCALHOST = exports.CarbonEvmNativeCurrency = void 0;
const constant_1 = require("../constant");
const ethermint_1 = require("../util/ethermint");
exports.CarbonEvmNativeCurrency = {
    decimals: 18,
    name: "SWTH",
    symbol: "SWTH",
};
exports.CARBON_EVM_LOCALHOST = {
    chainId: `0x${Number(ethermint_1.parseChainId(constant_1.CarbonEvmChainIDs[constant_1.Network.LocalHost])).toString(16)}`,
    blockExplorerUrls: ["https://evm-scan.carbon.network"],
    chainName: "Carbon EVM Localhost",
    rpcUrls: [`${constant_1.NetworkConfigs[constant_1.Network.LocalHost].evmJsonRpcUrl}`],
    nativeCurrency: exports.CarbonEvmNativeCurrency,
};
exports.CARBON_EVM_DEVNET = {
    chainId: `0x${Number(ethermint_1.parseChainId(constant_1.CarbonEvmChainIDs[constant_1.Network.DevNet])).toString(16)}`,
    blockExplorerUrls: ["https://evm-scan.carbon.network"],
    chainName: "Carbon EVM Devnet",
    rpcUrls: [`${constant_1.NetworkConfigs[constant_1.Network.DevNet].evmJsonRpcUrl}`],
    nativeCurrency: exports.CarbonEvmNativeCurrency,
};
exports.CARBON_EVM_TESTNET = {
    chainId: `0x${Number(ethermint_1.parseChainId(constant_1.CarbonEvmChainIDs[constant_1.Network.TestNet])).toString(16)}`,
    blockExplorerUrls: ["https://evm-scan.carbon.network"],
    chainName: "Carbon EVM Testnet",
    rpcUrls: [`${constant_1.NetworkConfigs[constant_1.Network.TestNet].evmJsonRpcUrl}`],
    nativeCurrency: exports.CarbonEvmNativeCurrency,
};
exports.CARBON_EVM_MAINNET = {
    chainId: `0x${Number(ethermint_1.parseChainId(constant_1.CarbonEvmChainIDs[constant_1.Network.MainNet])).toString(16)}`,
    blockExplorerUrls: ["https://evm-scan.carbon.network"],
    chainName: "Carbon EVM",
    rpcUrls: [`${constant_1.NetworkConfigs[constant_1.Network.MainNet].evmJsonRpcUrl}`],
    nativeCurrency: exports.CarbonEvmNativeCurrency,
};
exports.BSC_MAINNET = {
    chainId: "0x38",
    blockExplorerUrls: ["https://bscscan.com"],
    chainName: "BSC Mainnet",
    rpcUrls: [
        "https://bsc-dataseed2.binance.org/",
        "https://bsc-dataseed3.binance.org/",
        "https://bsc-dataseed4.binance.org/",
        "https://bsc-dataseed1.defibit.io/",
        "https://bsc-dataseed2.defibit.io/",
        "https://bsc-dataseed3.defibit.io/",
        "https://bsc-dataseed4.defibit.io/",
        "https://bsc-dataseed1.ninicoin.io/",
        "https://bsc-dataseed2.ninicoin.io/",
        "https://bsc-dataseed3.ninicoin.io/",
        "https://bsc-dataseed4.ninicoin.io/",
        "https://bsc-dataseed1.binance.org/",
    ],
    nativeCurrency: {
        decimals: 18,
        name: "Binance Coin",
        symbol: "BNB",
    },
};
exports.BSC_TESTNET = {
    chainId: "0x61",
    blockExplorerUrls: ["https://testnet.bscscan.com"],
    chainName: "BNB Smart Chain Testnet",
    rpcUrls: [
        "https://data-seed-prebsc-1-s1.bnbchain.org:8545",
    ],
    nativeCurrency: {
        decimals: 18,
        name: "Binance Coin",
        symbol: "tBNB",
    },
};
exports.ETH_MAINNET = {
    chainId: "0x1",
    rpcUrls: ["https://mainnet.infura.io/v3/"],
};
exports.ETH_TESTNET = {
    chainId: "0x5",
    rpcUrls: ["https://goerli.infura.io/v3/"],
};
exports.ARBITRUM_MAINNET = {
    chainId: "0xA4B1",
    blockExplorerUrls: ["https://explorer.arbitrum.io"],
    chainName: "Arbitrum One",
    rpcUrls: ["https://arb1.arbitrum.io/rpc"],
    nativeCurrency: {
        decimals: 18,
        name: "Ethereum",
        symbol: "ETH",
    },
};
exports.ARBITRUM_TESTNET = {
    chainId: "0x66EEB",
    blockExplorerUrls: [""],
    chainName: "Arbitrum Testnet",
    rpcUrls: ["https://rinkeby.arbitrum.io/rpc"],
    nativeCurrency: {
        decimals: 18,
        name: "Ethereum",
        symbol: "ETH",
    },
};
exports.POLYGON_MAINNET = {
    chainId: "0x89",
    blockExplorerUrls: ["https://polygonscan.com/"],
    chainName: "Polygon Mainnet",
    rpcUrls: ["https://polygon-rpc.com"],
    nativeCurrency: {
        decimals: 18,
        name: "Matic",
        symbol: "MATIC",
    },
};
exports.POLYGON_TESTNET = {
    chainId: "0x13881",
    blockExplorerUrls: ["https://mumbai.polygonscan.com"],
    chainName: "Polygon Mumbai",
    rpcUrls: ["https://polygon-mumbai.infura.io/v3/4458cf4d1689497b9a38b1d6bbf05e78"],
    nativeCurrency: {
        decimals: 18,
        name: "Matic",
        symbol: "MATIC",
    },
};
exports.OKC_MAINNET = {
    chainId: "0x42",
    blockExplorerUrls: ["https://www.oklink.com/okc"],
    chainName: "OKC Mainnet",
    rpcUrls: ["https://exchainrpc.okex.org"],
    nativeCurrency: {
        decimals: 18,
        name: "OKT",
        symbol: "OKT",
    },
};
exports.OKC_TESTNET = {
    chainId: "0x41",
    blockExplorerUrls: ["https://www.oklink.com/okc-test"],
    chainName: "OKC Testnet",
    rpcUrls: ["https://exchaintestrpc.okex.org"],
    nativeCurrency: {
        decimals: 18,
        name: "OKT",
        symbol: "OKT",
    },
};
exports.MANTLE_MAINNET = {
    chainId: "0x1388",
    blockExplorerUrls: ["https://explorer.mantle.xyz"],
    chainName: "Mantle Mainnet",
    rpcUrls: [
        "https://rpc.mantle.xyz/",
    ],
    nativeCurrency: {
        decimals: 18,
        name: "Mantle",
        symbol: "MNT",
    },
};
exports.MANTLE_TESTNET = {
    chainId: "0x138B",
    blockExplorerUrls: ["https://sepolia.mantlescan.xyz"],
    chainName: "Mantle Sepolia",
    rpcUrls: [
        "https://rpc.sepolia.mantle.xyz",
    ],
    nativeCurrency: {
        decimals: 18,
        name: "Mantle",
        symbol: "MNT",
    },
};
exports.OP_MAINNET = {
    chainId: "0xA",
    blockExplorerUrls: ["https://optimistic.etherscan.io"],
    chainName: "OP Mainnet",
    rpcUrls: [
        "https://mainnet.optimism.io",
    ],
    nativeCurrency: {
        decimals: 18,
        name: "Ethereum",
        symbol: "ETH",
    },
};
exports.OP_TESTNET = {
    chainId: "0xaa36a7",
    blockExplorerUrls: ["https://sepolia-optimism.etherscan.io"],
    chainName: "OP Sepolia Testnet",
    rpcUrls: [
        "https://sepolia.optimism.io",
    ],
    nativeCurrency: {
        decimals: 18,
        name: "Ethereum",
        symbol: "ETH",
    },
};
exports.AVALANCHE_MAINNET = {
    chainId: "0xa86a",
    blockExplorerUrls: ["https://snowtrace.io"],
    chainName: "Avalanche C-Chain",
    rpcUrls: [
        "https://api.avax.network/ext/bc/C/rpc",
    ],
    nativeCurrency: {
        "name": "Avalanche",
        "symbol": "AVAX",
        "decimals": 18,
    },
};
exports.AVALANCHE_TESTNET = {
    chainId: "0xa869",
    blockExplorerUrls: ["https://testnet.snowtrace.io"],
    chainName: "Avalanche Fuji Testnet",
    rpcUrls: [
        "https://ava-testnet.public.blastapi.io/ext/bc/C/rpc",
    ],
    nativeCurrency: {
        "name": "Avalanche",
        "symbol": "AVAX",
        "decimals": 18,
    },
};
exports.BASE_MAINNET = {
    chainId: "0x2105",
    blockExplorerUrls: ["https://basescan.org"],
    chainName: "Base Mainnet",
    rpcUrls: [
        "https://base-rpc.publicnode.com",
    ],
    nativeCurrency: {
        decimals: 18,
        name: "Ethereum",
        symbol: "ETH",
    },
};
exports.BASE_TESTNET = {
    chainId: "0x14a34",
    blockExplorerUrls: ["https://sepolia.basescan.org"],
    chainName: "Base Sepolia Testnet",
    rpcUrls: [
        "https://base-sepolia-rpc.publicnode.com",
    ],
    nativeCurrency: {
        decimals: 18,
        name: "Ethereum",
        symbol: "ETH",
    },
};
exports.MONAD_TESTNET = {
    chainId: "0x279f",
    blockExplorerUrls: ["https://testnet.monadexplorer.com"],
    chainName: "Monad Testnet",
    rpcUrls: [
        "https://testnet-rpc.monad.xyz",
    ],
    nativeCurrency: {
        decimals: 18,
        name: "Monad",
        symbol: "MON",
    },
};
